import { init as initApm } from "@elastic/apm-rum";

const isINT = () => {
    return window.location.hostname === "ntancis.tra.go.tz";
};

const isOGA = () => {
    return window.location.hostname === "tanoga.tra.go.tz";
};

const isEXT = () => {
    return window.location.hostname === "tanesw.tra.go.tz";
};

const isProd = () => {
    return isINT();
    // return isINT() || isOGA() || isEXT();
};

const getSys = () => {
    if (isINT()) return "int";
    if (isOGA()) return "oga";
    if (isEXT()) return "ext";
    return "unknown";
};

const getApp = () => {
    return process.env.REACT_APP_BASE?.slice(1, 4) ?? "unknown";
};

const apm = isProd()
    ? initApm({
          serviceName: `tancis-web-${getSys()}-${getApp()}`,
          serverUrl: "https://tancis-kibana.tra.go.tz:8200",
          environment: "production",
          // environment: "development",
      })
    : null;

export { apm, isINT };
